import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Kernel?",
  "description": "",
  "published": "2007-03-01T00:00:00.000Z",
  "redirect_from": ["/blog/kernel/swizec/275"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Not certain at all which version of the linux kernel this video envisualises, but what it shows looks rather fascinating really.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      